import EmailRecepientTable from "./EmailRecepientTable";
const EmailRecepient = () => {
  return <EmailRecepientTable />;
};

export default EmailRecepient;
